import { useCallback, useEffect, useRef, useState } from 'react';

// Shows the first `step` items of a long list and `step` more each time the sentinel scrolls into view.
export function useInfiniteList(total, step = 120, resetKey) {
  const [count, setCount] = useState(step);
  const observer = useRef(null);

  useEffect(() => { setCount(step); }, [resetKey, step]);

  const sentinel = useCallback((node) => {
    observer.current?.disconnect();
    if (!node) return;
    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setCount(n => n + step);
    }, { root: node.parentElement, rootMargin: '400px' });
    observer.current.observe(node);
  }, [step]);

  return { count: Math.min(count, total), hasMore: count < total, sentinel };
}
